module.exports = __webpack_public_path__ + "img/Ultra-Play-logo.2ffc40f7.png";